import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerCharacteristicModalComponent } from './historical-customer-characteristic-modal.component';
import { HistoricalCustomerCharacteristicComponent } from './historical-customer-characteristic.component';

@NgModule({
    declarations: [
        HistoricalCustomerCharacteristicComponent,
        HistoricalCustomerCharacteristicModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerCharacteristicComponent,
        HistoricalCustomerCharacteristicModalComponent
    ]
})

export class HistoricalCustomerCharacteristicModule {}
